import React from "react";
import Navigation from "./Navigation";
import { AboutMeSection } from "./AboutMeSection";
import { Hero } from "./Hero";
import { RecentWork } from "./RecentWork";
import { ServicesSection } from "./ServicesSection";
import { Reviews } from "./Reviews";
import { Footer } from "./Footer";

export const Home = () => {
  return (
    <div data-aos="fade-in">
      <header>
        <Navigation />
        <Hero />
      </header>
      <main>
        <AboutMeSection />
        <RecentWork />
        <ServicesSection />
        <Reviews />
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
};
